import React, { forwardRef, ReactNode } from 'react';
import {
  Modal as ChakraModal,
  ModalOverlay as ChakraModalOverlay,
  ModalContent as ChakraModalContent,
  ModalHeader as ChakraModalHeader,
  ModalFooter as ChakraModalFooter,
  ModalBody as ChakraModalBody,
  ModalCloseButton as ChakraModalCloseButton,
  ModalProps,
} from '@chakra-ui/react';

interface Props extends ModalProps {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}

export const Modal = forwardRef<HTMLElement, Props>(
  ({ children, header, footer, ...props }: Props, _ref): JSX.Element => {
    return (
      <ChakraModal {...props}>
        <ChakraModalOverlay />
        <ChakraModalContent>
          <ChakraModalHeader>{header}</ChakraModalHeader>
          <ChakraModalCloseButton />
          <ChakraModalBody>{children}</ChakraModalBody>
          <ChakraModalFooter>{footer}</ChakraModalFooter>
        </ChakraModalContent>
      </ChakraModal>
    );
  }
);
export type { Props as ModalProps };
